import { execAdmin } from '@src/apis/reware/utils';
import type {
  UpdatePricingRulePositionMutation,
  UpdatePricingRulePositionMutationVariables,
} from '@src/types/__generated/rewareAdminTypes';

const gql = String.raw;

export const updatePricingRulePosition = async ({
  partnerId,
  ruleId,
  newPosition,
}: UpdatePricingRulePositionMutationVariables) => {
  const query = gql`
    mutation updatePricingRulePosition(
      $partnerId: Int!
      $ruleId: Int!
      $newPosition: Int!
    ) {
      partner(id: $partnerId) {
        updatePricingRulePosition(
          ruleId: $ruleId
          newPosition: $newPosition
        ) {
          id
          position
        }
      }
    }
  `;

  const data = await execAdmin<
    UpdatePricingRulePositionMutationVariables,
    UpdatePricingRulePositionMutation
  >(query, { variables: { partnerId, ruleId, newPosition } });

  const result = data.partner?.updatePricingRulePosition;
  if (!result) {
    throw new Error(
      `updatePricingRulePosition: unexpected response — partner.updatePricingRulePosition is ${result === null ? 'null' : 'undefined'} (partnerId=${partnerId})`
    );
  }
  return result;
};
